import { Colors, theme } from "../utils/theme";

export const CUSTOM_HOST_COLORS = {
	default: {
		primaryBackground: theme.palette.primary.brand,
		secondaryBackground: theme.palette.primary.backgroundLight,
		tertiaryBackground: Colors['D19364'],
		primaryText: theme.palette.primary.shadow,
		secondaryText: theme.palette.primary.dark,
		borderPrimaryColor: theme.palette.primary.shadow,
		borderSecondaryColor: theme.palette.primary.dark,
	},
	'c8db2edb-721e-4406-9c63-ac1b0aeca5c3': {
		primaryBackground: Colors['F9172F'],
		secondaryBackground: theme.palette.primary.shadow,
		tertiaryBackground: Colors['BDBDBD'],
		primaryText: theme.palette.primary.light,
		secondaryText: theme.palette.primary.light,
		borderPrimaryColor: theme.palette.primary.light,
		borderSecondaryColor: theme.palette.primary.dark,
	},
};
